// extracted by mini-css-extract-plugin
module.exports = {"var-md":"768px","varMd":"768px","scrollToTop":"scrollToTop--1d59f","isActive":"isActive--e4158","arrow":"arrow--de903"};